export const prefixAllow = ['WK89', 'LEXY88', '1XHENG', 'VK789', 'LK789', 'ALD88', 'K88']

export const prefixAllowN = ['NX98', 'RSM69', 'KUB9']

export const prefixAllowT = ['VG89', 'XP99']
